import type { ReactNode, ButtonHTMLAttributes } from 'react';
import type { Verdict } from '@/state/store';
import { MetricHelp } from './MetricHelp';

export function Button({
  children, variant = 'solid', className = '', ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'solid' | 'ghost';
}) {
  return (
    <button type="button" className={`button button-${variant} ${className}`} {...props}>
      {children}
    </button>
  );
}

const VERDICT_STYLE: Record<Verdict, { dot: string; text: string; label: string }> = {
  pass: { dot: 'bg-[#367C61]', text: 'text-[#367C61]', label: '양호' },
  warn: { dot: 'bg-[#986D31]', text: 'text-[#986D31]', label: '주의' },
  fail: { dot: 'bg-[#B05C40]', text: 'text-[#B05C40]', label: '부적합' },
};

export function VerdictPill({ v }: { v: Verdict }) {
  const s = VERDICT_STYLE[v];
  return (
    <span className={`inline-flex items-center gap-1.5 text-[11px] font-mono ${s.text}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} aria-hidden="true" />
      {s.label}
    </span>
  );
}

export function Panel({ title, children }: { title?: string; children: ReactNode }) {
  return (
    <section className="panel">
      {title ? (
        <h2 className="mb-3 font-mono text-[11px] uppercase tracking-[0.14em] text-[var(--color-screen-dim)]">
          {title}
        </h2>
      ) : null}
      {children}
    </section>
  );
}

export function Stat({ label, value, hint }: { label: string; value: string; hint?: string }) {
  return (
    <MetricHelp label={label}>
      <span className="font-mono text-lg tabular-nums text-[var(--color-screen-fg)]">{value}</span>
      {hint ? <span className="text-[12px] leading-snug text-[var(--color-screen-dim)]">{hint}</span> : null}
    </MetricHelp>
  );
}
